"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
  x: "3.95",
  y: "15.35",
  width: "24.42",
  height: "1.3",
  transform: "translate(-5.73 22.17) rotate(-60.47)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M10.47,22.09A13.91,13.91,0,0,1,5,16.44C7.36,12,11.53,9.27,16,9.26h0a10,10,0,0,1,1.65.13l.68-1.2A12.87,12.87,0,0,0,16,8h0c-5,0-9.73,3.15-12.24,8.19a.66.66,0,0,0,0,.58,15.24,15.24,0,0,0,6.1,6.49Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M28.27,16.07a15.17,15.17,0,0,0-6.21-6.53l-.64,1.13A13.85,13.85,0,0,1,27,16.37c-2.32,4.42-6.49,7.16-10.94,7.17h0a11.76,11.76,0,0,1-1.78-.14l-.67,1.19a12.5,12.5,0,0,0,2.45.26h0c5.05,0,9.74-3.16,12.25-8.19A.68.68,0,0,0,28.27,16.07Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M19.79,13.55l-.74,1.31.89,1.53-2,3.42H16.24l-.74,1.3h2.86a.65.65,0,0,0,.56-.32l2.33-4.07a.63.63,0,0,0,0-.65Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M12.14,19.14l.74-1.31-.82-1.42L14,13h1.6l.74-1.31H13.64a.66.66,0,0,0-.56.33l-2.33,4.06a.63.63,0,0,0,0,.65Z"
}), /*#__PURE__*/_react["default"].createElement("g", {
  id: "Artboard-32"
})));
module.exports = exports.default;